import { fetch } from '@utils/utils';
import * as T from '@modules/hr-templates/days/_daysTypes';

const getDayTemplate = ({ addError }) => async (id: string): Promise<T.Day | {}> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/calendar/day/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Day = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const getAllDayTemplates = async (): Promise<T.Day[] | boolean> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/calendar/day/`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Day[] = await response.json();

    return json;
  } catch (err) {
    return false;
  }
};

export { getDayTemplate, getAllDayTemplates };



// WEBPACK FOOTER //
// ./src/modules/hr-templates/days/_daysActions.ts